import type {RichTextEditorInstance as Editor} from '@shopify/online-store-ui';
import {
  isListToggleActive,
  ParagraphType,
  toggleList,
} from '@shopify/online-store-ui';

export type ListContainerType = 'ordered' | 'unordered';

export function useSharedListProps(
  editor: Editor,
  listType: ListContainerType,
) {
  const {selection} = editor;
  const active = isListToggleActive(editor, {at: selection, listType});

  const onAction = () => {
    toggleList(editor, {
      listType,
      at: selection,
      defaultBlockType: ParagraphType,
    });
  };

  return {
    active,
    onAction,
  };
}
